import { Div } from './base';
import * as React from 'react';
export const LanguageTag = (props) => (React.createElement(Div, { css: {
        position: 'absolute',
        right: '$2',
        top: '$0',
        backgroundColor: '$primary-700',
        color: 'White',
        px: '$2',
        textTransform: 'uppercase',
        fontSize: '$sm',
        lineHeight: '$sm',
        roundedB: '$base',
        fontFamily: 'monospace',
    } }, props.language));
//# sourceMappingURL=language-tag.js.map